'use client';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const StyledDiscountBanner = styled.div`
  ${props => props.theme.typography[props.$typography]}
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  padding: ${props =>
    props.theme.spacing(props.$verticalPadding, props.$horizontalPadding)};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* This is needed to make sure it doesn't get */
  /* bigger when the text enters. */
  height: 40px;
  ${props =>
    props.$sticky &&
    css`
      position: fixed;
      top: 0;
      z-index: 100;
    `};
`;

export const OfferBannerText = styled.p`
  font-weight: inherit;
`;

export const OfferLink = styled(Link)`
  color: ${props => props.theme.colors.text.lightest};
  display: inline-flex;
  font-weight: bold;
  margin-left: 8px;
  padding: 1px;
  border: 2px solid transparent;
  border-bottom: 1px solid ${props => props.theme.colors.background.lightest};

  &:focus {
    padding-bottom: 0px;
    border-radius: 4px;
    border: 2px solid ${props => props.theme.colors.background.lightest};
  }
`;
